import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { KTSVG } from '../../../_metronic/helpers';
import Select from 'react-select';
import { FilterOptionOption } from 'react-select';
import DatePicker from 'react-datepicker';
import loadingimage from "../../../Assets/loading-buffering1.gif"
import moment from 'moment';

const OutstandingReport = () => {
  // State management
  const [data, setData] = useState<any[]>([]);
  const [grandCreditTotal, setgrandCreditTotal] = useState('');
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [agingReportData, setAgingReportData] = useState<any[]>([]);
  const [filteredAgingReportData, setFilteredAgingReportData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(11);
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [isMasterChecked, setIsMasterChecked] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [setAgingReport, setSetAgingReport] = useState(false);
  const [dateRange, setDateRange] = useState<[Date | undefined, Date | undefined]>([undefined, undefined]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAgingReport, setIsAgingReport] = useState(false);
  const [progress, setProgress] = React.useState<number>(0);
  const [showProgressBar, setShowProgressBar] = React.useState<boolean>(false);
  // Fetch data from APIs
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(
          'https://backendcway.causewaycargo.com/superadmin/allcustomercreditdetails',
          { method: 'GET', headers: { auth: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do' } }
        );
        const result = await response.json();

        if (result?.data?.consignee_data?.details && result?.data?.consignor_data?.details) {
          // Combine both consignee and consignor data
          const combinedData = [
            ...result.data.consignee_data.details,
            ...result.data.consignor_data.details,
          ];
          // Store the combined data
          setData(combinedData);
          console.log("Fetched and combined data:", combinedData);

          // Optional: Check for problematic entries
          combinedData.forEach((item, index) => {
            if (!item.customer || typeof item.customer !== 'string') {
              console.warn(`Invalid customer at index ${index}:`, item);
            }
          });

          setFilteredData(combinedData);
          setgrandCreditTotal(result.data.summary.grand_total);
        } else {
          console.error("Data structure is missing expected fields");
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false)
      }
    };

    const fetchAgingReportData = async () => {
      try {
        const response = await fetch(
          'https://backendcway.causewaycargo.com/superadmin/agingreport',
          { method: 'GET', headers: { auth: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do' } }
        );
        const result = await response.json();
        if (result?.data) {
          setAgingReportData(result.data);
          setFilteredAgingReportData(result.data);
        }
      } catch (error) {
        console.error('Error fetching aging report data:', error);
      }
    };

    fetchData();
    fetchAgingReportData();
  }, []);

  // Checkbox functionality
  const handleCheckboxChange = (item: any, isChecked: boolean) => {
    setSelectedData((prev) =>
      isChecked
        ? [...prev, item] // Add item if checked
        : prev.filter(
          (data) =>
            (data.booking_id || data.split_id) !== (item.booking_id || item.split_id) // Handle null booking_id
        )
    );
  };

  // Handle master checkbox change
  const handleMasterCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsMasterChecked(isChecked);

    // Set selected data based on whether setAgingReport is true or false
    if (setAgingReport) {
      // If setAgingReport is true, select all aging report data
      setSelectedData(isChecked ? filteredAgingReportData : []);
    } else {
      // If setAgingReport is false, select all regular data
      setSelectedData(isChecked ? filteredData : []);
    }
  };

  // Function to check if row is selected
  const isRowSelected = (item: any) =>
    selectedData.some((data) => (data.booking_id || data.split_id) === (item.booking_id || item.split_id));

  // Export to Excel function
  const handleExportToExcel = async () => {
    setShowProgressBar(true); // Show the progress bar
    setProgress(10); // Start progress

    const wb = XLSX.utils.book_new();
    setProgress(20); // Update progress

    const dataToExport =
      selectedData.length > 0
        ? selectedData
        : setAgingReport
          ? filteredAgingReportData
          : filteredData;

    let formattedData = dataToExport.map((item) => ({
      ...item,
      Booking_date: item.created_at
        ? moment(item.created_at).format("DD-MM-YYYY")
        : "N/A",
      created_at: item?.created_at
        ? moment(item?.created_at).format("DD-MM-YYYY")
        : "N/A",
    }));

    setProgress(40); // Update progress

    if (setAgingReport) {
      formattedData = formattedData.map(item => {
        const createdAt = new Date(item.created_at);
        const today = new Date();
        const diffTime = today.getTime() - createdAt.getTime();
        const agingCount = item.created_at ? Math.floor(diffTime / (1000 * 60 * 60 * 24)) : "0";

        return {
          "Booking ID": item.booking_id ? item.booking_id : item.split_id || "N/A",
          "Container ID": item.container_id ? item.container_id : item.shipment_id || "N/A",
          "Consignee": item.consignee || "N/A",
          "Consignor": item.consignor || "N/A",
          "Payment Mode": item.who_paid || "N/A",
          "Total Quantity": item.total_quantity || 0,
          "Total Price": item.booking_value || "0.00",
          "Need to Pay": item.amount_to_be_paid || "0.00",
          "Aging Count": agingCount,
          "Created Date": item.created_at || "N/A"
        };
      });
    } else {
      formattedData = formattedData.map(item => ({
        "Booking Date": item.Booking_date || "N/A",
        "Booking ID": item.booking_id ? item.booking_id : item.split_id || "N/A",
        "Shipment ID": item.journey_id || "N/A",
        "Consignor": item.consignor || "N/A",
        "Consignee": item.consignee || "N/A",
        "Total Quantity": item.total_quantity || 0,
        "Item": item.description || "N/A",
        "Credit value": item.credit_value || 0,
        "Amount": item.booking_value || 0
      }));
    }

    setProgress(60); // Update progress

    const fileName = setAgingReport ? "Aging_Report.xlsx" : "Outstanding_Report.xlsx";
    const ws = XLSX.utils.json_to_sheet(formattedData);

    if (!ws['!ref']) {
      console.warn('No data to export or worksheet reference is undefined');
      setShowProgressBar(false);
      return;
    }

    const range = XLSX.utils.decode_range(ws['!ref']);

    if (!setAgingReport) {
      const lastRow = range.e.r + 2;

      ws[XLSX.utils.encode_cell({ r: lastRow, c: 0 })] = { t: 's', v: 'Total Credit' };
      ws[XLSX.utils.encode_cell({ r: lastRow, c: 1 })] = {
        t: 'n',
        v: parseFloat(grandCreditTotal || '0'),
        z: '#,##0.00'
      };

      const grandAmountTotal = dataToExport.reduce(
        (sum, item) => sum + (parseFloat(item.booking_value) || 0),
        0
      );

      ws[XLSX.utils.encode_cell({ r: lastRow + 1, c: 0 })] = { t: 's', v: 'Total Amount' };
      ws[XLSX.utils.encode_cell({ r: lastRow + 1, c: 1 })] = {
        t: 'n',
        v: grandAmountTotal,
        z: '#,##0.00'
      };

      ws['!ref'] = XLSX.utils.encode_range(
        range.s,
        { r: lastRow + 1, c: range.e.c }
      );
    }

    setProgress(80); // Update progress

    const colWidths = [];
    const maxRow = setAgingReport ? range.e.r : range.e.r + 2;

    for (let col = 0; col <= range.e.c; col++) {
      colWidths[col] = 12;
      for (let row = range.s.r; row <= maxRow; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (ws[cellAddress]) {
          const cellValue = String(ws[cellAddress].v || '');
          const width = Math.max(12, cellValue.length * 1.2);
          colWidths[col] = Math.max(colWidths[col], width);
        }
      }
    }

    ws['!cols'] = colWidths.map(width => ({ width }));

    setProgress(90); // Almost done

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, fileName);

    setProgress(100); // Finished
    setTimeout(() => {
      setShowProgressBar(false);
      setProgress(0); // Reset progress bar after a small delay
    }, 1000);
  };



  // Pagination logic
  const totalPages = setAgingReport
    ? Math.ceil(filteredAgingReportData.length / itemsPerPage)
    : Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = setAgingReport
    ? filteredAgingReportData.slice(startIndex, startIndex + itemsPerPage)
    : filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handleDateChange = (update: [Date | null, Date | null]) => {
    const newDateRange: [Date | undefined, Date | undefined] = [
      update[0] || undefined,
      update[1] || undefined,
    ];
    setDateRange(newDateRange);
  };

  // useEffect(() => {
  // if (dateRange[0] && dateRange[1]) {
  // const startDate = new Date(dateRange[0]).setHours(0, 0, 0, 0);
  // const endDate = new Date(dateRange[1]).setHours(23, 59, 59, 999);

  // const filteredData = agingReportData.filter((item) => {
  // const createdAt = new Date(item.created_at).getTime();
  // return createdAt >= startDate && createdAt <= endDate;
  // });

  // setFilteredAgingReportData(filteredData);
  // setCurrentPage(1); // Reset to the first page
  // } else {
  // setFilteredAgingReportData(agingReportData);
  // setCurrentPage(1); // Reset to the first page
  // }
  // }, [dateRange, agingReportData]);

  // Normalize search term: trim spaces and replace multiple spaces with a single space

  // useEffect(() => {
  // if (normalizedSearchTerm) {
  // // Filter for main data
  // const searchFilter = data.filter(
  // (item) =>
  // (item.booking_id && item.booking_id.toString().includes(normalizedSearchTerm)) || // Ensure booking_id exists
  // (item.customer && item.customer.toLowerCase().includes(normalizedSearchTerm)) // Ensure customer exists
  // );
  // setFilteredData(searchFilter);

  // // Filter for aging report data
  // const agingReportFilter = agingReportData.filter(
  // (item) =>
  // (item.booking_id && item.booking_id.toString().includes(normalizedSearchTerm)) || // Ensure booking_id exists
  // (item.container_id && item.container_id.toString().includes(normalizedSearchTerm)) || // Ensure container_id exists
  // (item.consignee && item.consignee.toLowerCase().includes(normalizedSearchTerm)) || // Ensure consignee exists
  // (item.consignor && item.consignor.toLowerCase().includes(normalizedSearchTerm)) // Ensure consignor exists
  // );
  // setFilteredAgingReportData(agingReportFilter);
  // } else {
  // // Reset data if searchTerm is empty
  // setFilteredData(data);
  // setFilteredAgingReportData(agingReportData);
  // }
  // }, [normalizedSearchTerm, data, agingReportData]);


  // Normalize search term: trim spaces and replace multiple spaces with a single space
  const normalizedSearchTerm = searchTerm.trim().replace(/\s+/g, ' ').toLowerCase();
  // Add a space-insensitive version of the search term
  const noSpaceSearchTerm = searchTerm.trim().replace(/\s+/g, '').toLowerCase();

  useEffect(() => {
    let filteredData = [...agingReportData];

    // Apply date filter if date range is selected
    if (dateRange[0] && dateRange[1]) {
      const startDate = new Date(dateRange[0]).setHours(0, 0, 0, 0);
      const endDate = new Date(dateRange[1]).setHours(23, 59, 59, 999);

      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.created_at).getTime();
        return createdAt >= startDate && createdAt <= endDate;
      });
    }

    // Apply search filter
    if (normalizedSearchTerm) {
      filteredData = filteredData.filter((item) => {
        const bookingId = item.booking_id ? item.booking_id.toString().toLowerCase() : '';
        const splitId = item.split_id ? item.split_id.toString().toLowerCase() : ''; // Add split_id check
        const containerId = item.container_id ? item.container_id.toString().toLowerCase() : '';
        const consignee = item.consignee ? item.consignee.toLowerCase() : '';
        const consignor = item.consignor ? item.consignor.toLowerCase() : '';

        // Create versions without spaces for space-insensitive matching
        const bookingIdNoSpace = bookingId.replace(/\s+/g, '');
        const splitIdNoSpace = splitId.replace(/\s+/g, '');
        const containerIdNoSpace = containerId.replace(/\s+/g, '');
        const consigneeNoSpace = consignee.replace(/\s+/g, '');
        const consignorNoSpace = consignor.replace(/\s+/g, '');

        return (
          // Standard matching
          bookingId.includes(normalizedSearchTerm) ||
          containerId.includes(normalizedSearchTerm) ||
          consignee.includes(normalizedSearchTerm) ||
          consignor.includes(normalizedSearchTerm) ||
          // If booking_id is null, check split_id instead
          (!bookingId && splitId.includes(normalizedSearchTerm)) ||
          // Space-insensitive matching
          bookingIdNoSpace.includes(noSpaceSearchTerm) ||
          containerIdNoSpace.includes(noSpaceSearchTerm) ||
          consigneeNoSpace.includes(noSpaceSearchTerm) ||
          consignorNoSpace.includes(noSpaceSearchTerm) ||
          (!bookingId && splitIdNoSpace.includes(noSpaceSearchTerm))
        );
      });
    }

    setFilteredAgingReportData(filteredData);
    setCurrentPage(1); // Reset pagination
  }, [dateRange, normalizedSearchTerm, noSpaceSearchTerm, agingReportData]);

  useEffect(() => {
    // Start with original data
    let filteredTableData = [...data];

    // Apply search filter if term exists
    if (normalizedSearchTerm) {
      filteredTableData = filteredTableData.filter(
        (item) => {
          // Convert booking_id to lowercase string for case-insensitive comparison
          const bookingId = item.booking_id ? item.booking_id.toString().toLowerCase() : '';
          const customer = item.customer ? item.customer.toLowerCase() : '';

          // Create versions without spaces for space-insensitive matching
          const bookingIdNoSpace = bookingId.replace(/\s+/g, '');
          const customerNoSpace = customer.replace(/\s+/g, '');

          return (
            // Standard matching
            bookingId.includes(normalizedSearchTerm) ||
            customer.includes(normalizedSearchTerm) ||
            // Space-insensitive matching
            bookingIdNoSpace.includes(noSpaceSearchTerm) ||
            customerNoSpace.includes(noSpaceSearchTerm)
          );
        }
      );
    }

    setFilteredData(filteredTableData);
  }, [normalizedSearchTerm, noSpaceSearchTerm, data]);


  // Search filter functionality
  // useEffect(() => {
  // if (normalizedSearchTerm !== '') { // Check if searchTerm is not empty
  // if (setAgingReport) {
  // const agingReportFilter = agingReportData.filter((item) => {
  // // Normalize item text fields by removing spaces
  // const normalizedBookingId = item.booking_id ? item.booking_id.toString().toLowerCase() : '';
  // const normalizedContainerId = item.container_id ? item.container_id.toString().toLowerCase() : '';
  // const normalizedConsignee = item.consignee ? item.consignee.toLowerCase() : '';
  // const normalizedConsignor = item.consignor ? item.consignor.toLowerCase() : '';

  // // Additional normalized versions with spaces removed
  // const compactConsignee = normalizedConsignee.replace(/\s+/g, '');
  // const compactConsignor = normalizedConsignor.replace(/\s+/g, '');
  // const compactSearchTerm = normalizedSearchTerm.replace(/\s+/g, '');

  // return (
  // normalizedBookingId.includes(normalizedSearchTerm) ||
  // normalizedContainerId.includes(normalizedSearchTerm) ||
  // normalizedConsignee.includes(normalizedSearchTerm) ||
  // normalizedConsignor.includes(normalizedSearchTerm) ||
  // // Check for matches with spaces removed
  // compactConsignee.includes(compactSearchTerm) ||
  // compactConsignor.includes(compactSearchTerm)
  // );
  // });
  // setFilteredAgingReportData(agingReportFilter);
  // } else {
  // const searchFilter = data.filter((item) => {
  // // Normalize item text fields
  // const normalizedBookingId = item.booking_id ? item.booking_id.toString().toLowerCase() : '';
  // const normalizedCustomer = item.customer ? item.customer.toLowerCase() : '';

  // // Additional normalized versions with spaces removed
  // const compactCustomer = normalizedCustomer.replace(/\s+/g, '');
  // const compactSearchTerm = normalizedSearchTerm.replace(/\s+/g, '');

  // return (
  // normalizedBookingId.includes(normalizedSearchTerm) ||
  // normalizedCustomer.includes(normalizedSearchTerm) ||
  // // Check for matches with spaces removed
  // compactCustomer.includes(compactSearchTerm)
  // );
  // });
  // setFilteredData(searchFilter);
  // }
  // setCurrentPage(1); // Reset pagination
  // } else {
  // // Reset data if search is cleared
  // if (setAgingReport) {
  // setFilteredAgingReportData(agingReportData);
  // } else {
  // setFilteredData(data);
  // }
  // setCurrentPage(1);
  // }
  // }, [normalizedSearchTerm, data, agingReportData, setAgingReport]);

  // Toggle aging report view
  const handleToggleAgingReport = () => {
    setSetAgingReport((prev) => !prev);
    setCurrentPage(1); // Reset to first page when toggling view
    setSelectedData([]); // Clear selections
    setIsMasterChecked(false); // Uncheck master checkbox
  };

  // Customer filter functionality
  const customerOptions = data
    .filter((item) => typeof item.customer === 'string' && item.customer.trim() !== '')
    .map((item) => ({
      value: item.customer,
      label: item.customer,
    }));


  const handleCustomerSelectChange = (selectedOptions: any) => {
    let filteredData: any[];

    if (!selectedOptions || selectedOptions.length === 0) {
      // If no customers are selected, show all data
      filteredData = data;
    } else {
      // Filter the data based on selected options
      filteredData = data.filter((item) =>
        selectedOptions.some((selected: any) => selected?.value === item.customer)
      );
    }

    // Calculate the new grand total from filtered data
    const newgrandCreditTotal = filteredData.reduce((total, item) => {
      // Ensure we're only adding numeric credit values
      const creditValue = parseFloat(item.credit_value) || 0;
      return total + creditValue;
    }, 0);

    // Update both filtered data and grand total
    setFilteredData(filteredData);
    setgrandCreditTotal(newgrandCreditTotal.toFixed(2)); // Convert to string with 2 decimal places
    setCurrentPage(1); // Reset to first page after filtering
  };

  //-------------------Particular out standing------------------
  const [outstandingData, setOutstandingData] = useState<any | null>(null);
  const [showOutstandingModal, setShowOutstandingModal] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Handle API call and modal toggle
  const handleViewOutstanding = async (booking_id: any) => {
    try {
      const response = await fetch("https://backendcway.causewaycargo.com/superadmin/particularagingreport", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
        },
        body: JSON.stringify({ booking_id }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === "success") {
        setOutstandingData(result.data);
        setShowOutstandingModal(true);
        setError(null);
      } else {
        throw new Error("Failed to fetch booking data");
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(`Error: ${err.message}`);
      } else {
        setError("An unknown error occurred");
      }
    }
  };


  return (
    <div className="card px-lg-8 py-10">
      {showProgressBar && (
        <>
          <div className="modal-backdrop shadow-lg rounded-5">
            <div className="modal d-block" tabIndex={-1} role="dialog">
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content pb-10 pt-4">
                  <div className="modal-header py-2 d-flex justify-content-end">
                    <div className="modal-body">
                      <h5 className="mb-4">Exporting Data...</h5>
                      <div className="progress" style={{ height: "20px" }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                          role="progressbar"
                          style={{ width: `${progress}%` }}
                          aria-valuenow={progress}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          {Math.round(progress)}%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="d-flex justify-content-between gap-5 px-0 flex-wrap mb-6">
        <div className='d-flex align-items-center flex-wrap gap-5'>
          {!setAgingReport && (
            <Select
              isMulti
              options={customerOptions}
              onChange={handleCustomerSelectChange}
              placeholder="Select Customers"
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  cursor: 'pointer',
                  minWidth: '200px',
                  width: '100%',
                  outline: 'none',
                }),
              }}
              className="w-100 w-md-auto"
              menuPlacement="auto"
              filterOption={(
                option: FilterOptionOption<any>,
                inputValue: string
              ) => {
                if (!option.label || typeof inputValue !== 'string') return false;

                const normalizedLabel = option.label.toLowerCase().replace(/\s/g, '');
                const normalizedInput = inputValue.toLowerCase().replace(/\s/g, '');
                return normalizedLabel.includes(normalizedInput);
              }}
            />
          )}

          <input
            type="text"
            className="form-control w-100 w-md-auto"
            placeholder={setAgingReport ? "Search by Booking ID or Customer Name" : "Search by Booking ID"}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div
            onClick={handleToggleAgingReport}
            className="form-control w-100 w-md-auto "
            style={{
              cursor: 'pointer',
              backgroundColor: setAgingReport ? '#333' : '',
              color: setAgingReport ? '#ffffff' : '',

            }}
          >
            Aging Report
          </div>
        </div>
        <div className='d-flex align-items-center gap-2'>
          {setAgingReport ? (
            <DatePicker
              selectsRange
              className="form-control w-100 w-md-auto"
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={(update) => handleDateChange(update as [Date | null, Date | null])}
              isClearable
              placeholderText="Select a date range"
            />
          ) : (
            <div
              className={`px-4 py-3 gap-3 d-flex btn ${parseFloat(grandCreditTotal) < 0 ? 'bg-danger text-white' : 'bg-success text-white'}`}
            >
              <span>
                {grandCreditTotal ? parseFloat(grandCreditTotal).toLocaleString() : 0} QAR
              </span>
            </div>
          )}

          <div>
            <button
              className="btn btn-danger form-control"
              onClick={handleExportToExcel}
              disabled={selectedData.length === 0}
            >
              Export to Excel
            </button>
          </div>
        </div>
      </div>

      <div className="card-body py-3 px-0">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
            <img src={loadingimage} alt="Loading..." className="w-20" />
          </div>
        ) : (
          <div className="table-responsive">
            {/* Render original data table */}
            {!setAgingReport && (
              <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                <thead>
                  <tr className="fw-bolder text-muted">
                    <th className="w-25px">
                      <input
                        type="checkbox"
                        checked={isMasterChecked}
                        onChange={handleMasterCheckboxChange}
                        className="form-check-input"
                      />
                    </th>
                    <th className="min-w-120px">Booking Date</th>
                    <th className="min-w-120px">Booking ID</th>
                    <th className="min-w-120px">Shipment ID</th>
                    <th className="min-w-120px">Consignor</th>
                    <th className="min-w-120px">Consignee</th>
                    <th className="min-w-120px">Total Quantity</th>
                    <th className="min-w-120px">Item</th>
                    <th className="min-w-120px">Credit Value</th>
                    <th className="min-w-120px">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item, index) => (
                      <tr key={index} className="align-middle">
                        <td>
                          <input
                            type="checkbox"
                            checked={isRowSelected(item)}
                            onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                            className="form-check-input"
                          />
                        </td>
                        <td className='text-dark fw-bolder text-hover-primary'>{item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : "N/A"}</td>
                        <td>{item.booking_id ? item.booking_id : item.split_id || "N/A"}</td>
                        <td>{item.journey_id || "N/A"}</td>
                        <td>{item.consignor || "N/A"}</td>
                        <td>{item.consignee || "N/A"}</td>
                        <td>{item.total_quantity || "N/A"}</td>
                        <td>{item.description || "N/A"}</td>
                        <td
                          className={(item.credit_value) < 0 ? 'text-danger' : ''}
                        >
                          {(item.credit_value)} QAR
                        </td>
                        <td>
                          {(item.booking_value)} QAR
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center py-4 text-gray-500" colSpan={12}> 🚫 No reports available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {/* Render aging report table */}
            {setAgingReport && (
              <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                <thead>
                  <tr className="fw-bolder text-muted">
                    <th className="w-25px">
                      <input
                        type="checkbox"
                        checked={isMasterChecked}
                        onChange={handleMasterCheckboxChange}
                        className="form-check-input"
                      />
                    </th>
                    <th className="min-w-120px">Booking ID</th>
                    <th className="min-w-120px">Container ID</th>
                    <th className="min-w-120px">Consignee</th>
                    <th className="min-w-120px">Consignor</th>
                    <th className="min-w-120px">Payment Mode</th>
                    <th className="min-w-120px">Total Quantity</th>
                    <th className="min-w-120px">Total Price</th>
                    <th className="min-w-120px">Need to Pay</th>
                    <th className="min-w-120px">Aging Count</th>
                    <th className="min-w-120px">Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item, index) => (
                      <tr key={index} className="align-middle">
                        <td>
                          <input
                            type="checkbox"
                            checked={isRowSelected(item)}
                            onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                            className="form-check-input"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            onClick={() => handleViewOutstanding(item.booking_id || item.split_id)}
                            className="btn btn-link p-0 m-0 text-dark fw-bolder text-hover-primary"
                          // className=' text-dark fw-bolder text-hover-primary'
                          >
                            {item.booking_id ? item.booking_id : item.split_id || "N/A"}
                          </button>
                        </td>

                        <td>{item.container_id || "N/A"}</td>
                        <td>{item.consignee}</td>
                        <td>{item.consignor}</td>
                        <td>{item.who_paid}</td>
                        <td>{item.total_quantity}</td>
                        <td>{item.booking_value} QAR</td>
                        <td>
                          {item.amount_to_be_paid} QAR
                        </td>
                        {/* <td>{item.booking_aging_count}</td> */}
                        <td>
                          {(() => {
                            const createdAt = new Date(item.created_at);
                            const today = new Date();

                            const createdAtDateOnly = new Date(createdAt.getFullYear(), createdAt.getMonth(), createdAt.getDate());
                            const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                            const diffTime = todayDateOnly.getTime() - createdAtDateOnly.getTime();
                            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

                            return diffDays;
                          })()}
                        </td>




                        <td>
                          {moment(item.created_at).format('DD-MM-YYYY')}

                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10} className="text-center py-4 text-gray-500">
                        🚫 No reports available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Pagination */}
        {currentData.length > 0 && (
          <div className="d-flex justify-content-center align-items-center mt-6">
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <button
                  className="btn btn-light-primary me-1 px-4 py-2"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <KTSVG path="/media/icons/duotune/arrows/arr079.svg" className="svg-icon-3" />
                </button>
                <div>
                  {Array.from({ length: totalPages }, (_, i) => {
                    const pageNumber = i + 1;

                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={pageNumber}
                          className={`btn btn-light-primary mx-1 px-4 py-2 ${currentPage === pageNumber ? 'active' : ''}`}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      );
                    }

                    if (pageNumber === currentPage - 2 || pageNumber === currentPage + 2) {
                      return (
                        <span key={pageNumber} className="mx-2 text-muted">
                          ...
                        </span>
                      );
                    }

                    return null;
                  })}
                </div>
                <button
                  className="btn btn-light-primary px-4 py-2 ms-1"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <KTSVG path="/media/icons/duotune/arrows/arr080.svg" className="svg-icon-3" />
                </button>
              </div>
            )}
          </div>
        )}

        {showOutstandingModal && (
          <div className="modal-backdrop shadow-lg rounded-5">
            <div className="modal fade show d-block" tabIndex={-1} role="dialog">
              <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content pb-3 pt-4">
                  <div className="modal-header py-2 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowOutstandingModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body-dummy">
                    {outstandingData && outstandingData.length > 0 ? (
                      <div className="p-3">
                        <div className="row mb-3 px-6">
                          <div className="col-md-6">
                            <div className="mb-3 d-flex flex-column" style={{ rowGap: "9px" }}>
                              <span className="text-sm pb-2">Booking ID:</span>
                              <h6>{outstandingData[0].booking_id}</h6>
                            </div>
                            <div className="mb-3 d-flex flex-column" style={{ rowGap: "9px" }}>
                              <span className="text-sm">Container ID:</span>
                              <h6>{outstandingData[0].container_id || 'N/A'}</h6>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3 d-flex flex-column" style={{ rowGap: "9px" }}>
                              <span className="text-sm">Consignee Name:</span>
                              <h6>{outstandingData[0].consignee}</h6>
                            </div>
                            <div className="mb-3 d-flex flex-column" style={{ rowGap: "9px" }}>
                              <span className="text-sm">Consignor Name:</span>
                              <h6>{outstandingData[0].consignor}</h6>
                            </div>
                          </div>
                        </div>

                        <div className="bg-light-primary rounded p-3 px-6 py-3">
                          <div className="row mb-3">
                            <div className="col-sm-4 mb-3">
                              <p className="text-sm">Aging count</p>
                              <h6>{outstandingData[0].booking_aging_count}</h6>
                            </div>
                            <div className="col-sm-4 mb-3">
                              <p className="text-sm">Booking Date</p>
                              <h6>{new Date(outstandingData[0].created_at).toLocaleDateString('en-GB')}</h6>
                            </div>
                            <div className="col-sm-4 mb-3">
                              <p className="text-sm">Payment Mode</p>
                              <h6>{outstandingData[0].payment_mode}</h6>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-4 mb-3">
                              <p className="text-sm">Item</p>
                              <h6>{outstandingData[0].items}</h6>
                            </div>

                            <div className="col-sm-4 mb-3 text-start">
                              <p className="text-sm">Total Amount</p>

                              <h6>
                                {outstandingData[0]?.payment_mode === 'normal booking' && (
                                  ` ${parseFloat(outstandingData[0].nrml_qty_total_price) % 1 === 0
                                    ? parseInt(outstandingData[0].nrml_qty_total_price)
                                    : parseFloat(outstandingData[0].nrml_qty_total_price).toFixed(2)} QAR`
                                )}
                                {outstandingData[0]?.payment_mode === 'split booking' && (
                                  ` ${parseFloat(outstandingData[0].split_total_price) % 1 === 0
                                    ? parseInt(outstandingData[0].split_total_price)
                                    : parseFloat(outstandingData[0].split_total_price).toFixed(2)} QAR`
                                )}
                                {outstandingData[0]?.payment_mode === 'CBM Rate Method' && (
                                  ` ${parseFloat(outstandingData[0].total_cbm_price) % 1 === 0
                                    ? parseInt(outstandingData[0].total_cbm_price)
                                    : parseFloat(outstandingData[0].total_cbm_price).toFixed(2)} QAR`
                                )}
                                {outstandingData[0]?.payment_mode === 'Piece Rate Method' && (
                                  ` ${parseFloat(outstandingData[0].total_pieces_price) % 1 === 0
                                    ? parseInt(outstandingData[0].total_pieces_price)
                                    : parseFloat(outstandingData[0].total_pieces_price).toFixed(2)} QAR`
                                )}
                                {outstandingData[0]?.payment_mode === 'Invoice Value Method' && (
                                  ` ${parseFloat(outstandingData[0].total_invoice_price) % 1 === 0
                                    ? parseInt(outstandingData[0].total_invoice_price)
                                    : parseFloat(outstandingData[0].total_invoice_price).toFixed(2)} QAR`
                                )}
                                {outstandingData[0]?.payment_mode === 'Normal Unit Price Method' && (
                                  ` ${parseFloat(outstandingData[0].nrml_qty_total_price) % 1 === 0
                                    ? parseInt(outstandingData[0].nrml_qty_total_price)
                                    : parseFloat(outstandingData[0].nrml_qty_total_price).toFixed(2)} QAR`
                                )}
                              </h6>
                            </div>
                          </div>

                          {/* Add additional fields based on the payment_mode */}
                          {outstandingData[0].payment_mode === "normal booking" && (
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Normal Box Quantity</p>
                                <h6>{outstandingData[0].nrml_payment_quantity}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Normal Unit Price</p>
                                <h6>{outstandingData[0].nrml_quantity_price}</h6>
                              </div>
                            </div>
                          )}
                          {outstandingData[0].payment_mode === "split booking" && (
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Large Box Quantity</p>
                                <h6>{outstandingData[0].large_box_quantity}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Medium Box Quantity</p>
                                <h6>{outstandingData[0].medium_box_quantity}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Small Box Quantity</p>
                                <h6>{outstandingData[0].small_box_quantity}</h6>
                              </div>
                            </div>
                          )}
                          {outstandingData[0].payment_mode === "CBM Rate Method" && (
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">CBM Quantity</p>
                                <h6>{outstandingData[0].cbm_value}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">CBM Price</p>
                                <h6>{outstandingData[0].total_cbm_price}</h6>
                              </div>
                            </div>
                          )}
                          {outstandingData[0].payment_mode === "Piece Rate Method" && (
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Total Pieces</p>
                                <h6>{outstandingData[0].total_pieces}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Pieces Price</p>
                                <h6>{outstandingData[0].piece_value}</h6>
                              </div>
                            </div>
                          )}
                          {outstandingData[0].payment_mode === "Invoice Value Method" && (
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Invoice Value</p>
                                <h6>{outstandingData[0].invoice_value}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Invoice Percentage</p>
                                <h6>{outstandingData[0].invoice_percentage}%</h6>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="error-message text-center py-4 text-gray-500">🚫 No data available</div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div >
  );
};

export default OutstandingReport;